import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export interface IMessagePageFilterLists {
    units: IIdTitleNode[];
    companies: IIdTitle[];
    modifyUsers: IIdTitle[];
    dynamicTimeFilters: IIdTitle[];
}

export interface IMessagePageFilterStateWithoutDates {
    selectedUnitIds: string[];
    selectedCompanyIds: string[];
    selectedModifyUserCodes: string[];
    selectedDynamicTimeFilterId: string;
}

export interface IMessagePageFilterState extends IMessagePageFilterStateWithoutDates {
    selectedStartDate: number;
    selectedEndDate: number
}

export interface IMessagePageGeneralFilter {
    startDate: number;
    endDate: number;
    unitIds: string[];
    companyIds: string[];
    modifyUserCodes: string[];
    dynamicTimeFilterId: number;
}

export interface IMessagePageGeneralFilterChange extends IMessagePageGeneralFilter {
    notChanged: boolean;
}

export const getMessagePageGeneralFilterFromState = (state: IMessagePageFilterState): IMessagePageGeneralFilter => {
    return {
        startDate: state?.selectedStartDate ? state.selectedStartDate : null,
        endDate: state?.selectedEndDate ? state.selectedEndDate : null,
        unitIds: state?.selectedUnitIds ? state.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [],
        companyIds: state?.selectedCompanyIds ? state.selectedCompanyIds.filter(i => i !== Base.emptyGuid) : [],
        modifyUserCodes: state?.selectedModifyUserCodes ? state.selectedModifyUserCodes.filter(i => !!i) : [],
        dynamicTimeFilterId: state?.selectedDynamicTimeFilterId ? parseInt(state.selectedDynamicTimeFilterId, 10) : 0
    };
};

export const getMessagePageFilterStateFromGeneralFilter = (generalFilter: any): IMessagePageFilterState => {
    return {
        selectedStartDate: generalFilter?.startDate ? generalFilter.startDate : 0,
        selectedEndDate: generalFilter?.endDate ? generalFilter.endDate : 0,
        selectedUnitIds: generalFilter && generalFilter.unitIds && generalFilter.unitIds.length > 0 ? generalFilter.unitIds : [Base.emptyGuid],
        selectedCompanyIds: generalFilter && generalFilter.companyIds && generalFilter.companyIds.length > 0 ? generalFilter.companyIds : [Base.emptyGuid],
        selectedModifyUserCodes: generalFilter && generalFilter.modifyUserCodes && generalFilter.modifyUserCodes.length > 0 ? generalFilter.modifyUserCodes : [""],
        selectedDynamicTimeFilterId: !Base.isNullOrUndefined(generalFilter?.dynamicTimeFilterId) ? generalFilter.dynamicTimeFilterId.toString(10) : "0"
    };
};

export const getMessagePageGeneralFilterNotChanged = (prevFilter: IMessagePageGeneralFilter, filter: IMessagePageGeneralFilter): boolean => {
    return (prevFilter.startDate ?? -99).toString(10) === (filter.startDate ?? -99).toString(10) &&
        (prevFilter.endDate ?? -99).toString(10) === (filter.endDate ?? -99).toString(10) &&
        Base.equalStrArrays(prevFilter.unitIds, filter.unitIds) &&
        Base.equalStrArrays(prevFilter.companyIds, filter.companyIds) &&
        Base.equalStrArrays(prevFilter.modifyUserCodes, filter.modifyUserCodes) &&
        prevFilter.dynamicTimeFilterId.toString(10) === filter.dynamicTimeFilterId.toString(10);
};

export const getMessagePageGeneralFilterChange = (prevProps: IMessagePageFilterState, props: IMessagePageFilterState): IMessagePageGeneralFilterChange => {
    const prevFilter = getMessagePageGeneralFilterFromState(prevProps);
    const filter = getMessagePageGeneralFilterFromState(props);
    return {
        ...filter,
        notChanged: getMessagePageGeneralFilterNotChanged(prevFilter, filter)
    };
};
